var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPagerdutymonitoringService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 349 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "fill-current w-8 h-8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h349v349H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#06AC38",
    d: "M0 0h349v349H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.896 220.349H119.6v47.681h26.296v-47.681ZM218.339 97.77c-14.018-7.573-23.841-8.8-46.863-8.8H119.6v108.562h51.671c20.465 0 35.813-1.228 49.319-10.232 14.734-9.721 22.408-25.99 22.408-44.817 0-20.259-9.413-36.528-24.659-44.714Zm-41.031 77.046h-31.412v-62.62l29.673-.204c27.013-.205 40.519 9.209 40.519 30.798 0 23.227-16.781 32.026-38.78 32.026Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerdutymonitoringService);
export default __webpack_public_path__ + "static/media/pagerduty.monitoring-service.25291e0c8864d2c5904ce203a598fa1f.svg";
export { ForwardRef as ReactComponent };